import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForgotPassword } from "../../api/effects/mutations/ForgotPassword/forgotPassword";
import { WarningModal } from "../../components/WarningModal";

const RootGrid = styled(Grid)(({ theme }) => ({
  height: "90vh",
  backgroundImage: `url(${process.env.PUBLIC_URL}/images/BackgroundJob.svg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  [theme.breakpoints.down("sm")]: {
    backgroundSize: "cover",
  },
}));

const SquareGrid = styled(Grid)({
  backgroundColor: "#FFF",
  height: "auto",
  width: "100%",
  maxWidth: "90vw",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "2%",
});

const ClearLink = styled(Link)({
  color: "#150A33",
  textDecoration: "none",
  fontSize: ".8em",
  padding: "3%",
});

const ItemGrid = styled(Grid)({
  width: "100%",
  textAlign: "center",
});

const ItemTitleGrid = styled(Grid)({
  width: "100%",
  textAlign: "center",
  paddingBottom: "4vh",
});

const ButtonFull = styled(Button)({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
});

const TextFieldFull = styled(TextField)({
  width: "90%",
});

export default function ForgotPasswordChangePage() {
  const { token } = useParams();
  const [password, setPassword] = useState({
    PASSWORD: "",
    CONFIRM_PASSWORD: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState("");

  const navigate = useNavigate();

  const { mutateAsync: forgotPassword, isSuccess } = useForgotPassword({
    onSuccess() {
      setWarningModalText("Change Password Success");
      setWarningModalState(true);
    },
    onError() {
      setWarningModalText("Change Password Error");
      setWarningModalState(true);
      console.log("Error");
    },
  });

  const forgotSuccess = () => {
    setWarningModalState(false);
    navigate("/Login");
  };

  const forgotPush = () => {
    if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(password.PASSWORD)
    ) {
      if (password.PASSWORD === password.CONFIRM_PASSWORD) {
        forgotPassword({
          token: token!,
          PASSWORD: password.PASSWORD,
          CONFIRM_PASSWORD: password.CONFIRM_PASSWORD,
        });
      } else {
        setWarningModalText("Password Not Same.");
        setWarningModalState(true);
      }
    } else {
      setWarningModalText(
        "Minimum 8 characters including at least one of each uppercase, lowercase, and number."
      );
      setWarningModalState(true);
    }
  };

  return (
    <>
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          isSuccess ? forgotSuccess() : setWarningModalState(false);
        }}
        text={warningModalText}
      />
      <RootGrid container justifyContent="center" alignItems="center">
        <SquareGrid
          item={true}
          xs={12}
          sm={9}
          md={6}
          lg={3}
          spacing={1}
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
        >
          <ItemTitleGrid item>
            <Typography variant="h4">Change Password</Typography>
          </ItemTitleGrid>
          <ItemGrid item>
            <TextFieldFull
              value={password.PASSWORD}
              variant="outlined"
              label="New Password"
              type={showPassword ? "text" : "password"}
              onChange={(e) => {
                setPassword({
                  ...password,
                  PASSWORD: e.target.value,
                });
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="start"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              helperText="Minimum 8 characters including at least one of each uppercase, lowercase, and number."
            />
          </ItemGrid>
          <ItemGrid item>
            <TextFieldFull
              value={password.CONFIRM_PASSWORD}
              variant="outlined"
              label="Confirm Password"
              type={showPassword ? "text" : "password"}
              onChange={(e) => {
                setPassword({
                  ...password,
                  CONFIRM_PASSWORD: e.target.value,
                });
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="start"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              helperText="Must Matched With Password"
            />
          </ItemGrid>
          <ItemGrid item>
            <ButtonFull variant="contained" onClick={forgotPush}>
              Save
            </ButtonFull>
          </ItemGrid>
        </SquareGrid>
      </RootGrid>
    </>
  );
}
